import styled from 'styled-components';
import { Label as LabelR } from 'reactstrap';

export const Th = styled.th`
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  background: #e9ecef;
`;

export const Td = styled.td`
  padding-top: 5px !important;
  padding-bottom: 5px !important;
`;

export const Label = styled(LabelR)`
  font-size: 1rem;
  font-weight: 400;
  color: #fff;
`;
